// extracted by mini-css-extract-plugin
module.exports = {"ContentSection_margin":"ContentSection_ContentSection_margin__VABsd","ContentSection_padding":"ContentSection_ContentSection_padding__w__ea"};